export const SPREADSHEET = "spreadsheet";
export const PAGE = "page";
export const PAGE_ALBUM = "page_album";
export const PAGE_LIST = "page_list";
export const PAGE_COMPACT = "page_compact";
export const INTEGRATIONS = "integrations";
